import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

export const initSentry = () => {
  const global = window as any;
  if (global._sentryInitialized) return;

  const dsn = import.meta.env.VITE_SENTRY_DSN;
  
  if (!dsn) {
    console.warn("⚠️ Sentry DSN not found. Observability disabled.");
    return;
  }

  Sentry.init({
    dsn,
    ignoreErrors: [
      // Ignore CefSharp / Outlook Safe Links bot scanner noise
      "Object Not Found Matching Id",
      // Ignore automated bot network timeouts for third-party scripts
      "failed_to_load_clerk_js_timeout",
      "NavigatorLockAcquireTimeoutError",
    ],
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, 
    tracePropagationTargets: ["localhost", /^https:\/\/snap-calc-shop\.vercel\.app/, /^https:\/\/cartlens\.vercel\.app/, /^https:\/\/cartlens\.co/],
    // Session Replay (the integration is added by enableSentryReplay once the
    // visitor allows Analytics cookies)
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    
    environment: window.location.hostname === 'cartlens.co' || window.location.hostname === 'www.cartlens.co' ? 'production' : 
                 window.location.hostname === 'cartlens.vercel.app' ? 'preview' : 'staging',
  });

  global._sentryInitialized = true;
};

let replayEnabled = false;
export const enableSentryReplay = () => {
  if (replayEnabled || !(window as any)._sentryInitialized) return;
  replayEnabled = true;
  Sentry.addIntegration(Sentry.replayIntegration());
};

export const wrapApp = (App: React.ComponentType) => {
  return Sentry.withProfiler(App);
};
